/** The two `package_type` values searched — one request each, run in parallel. */
export enum SearchPackageType {
  Photo = 'photo',
  Video = 'video',
}

/** Which of a result's two urls is the one that moves. */
export enum SearchMediaType {
  Image = 'image',
  Video = 'video',
}

/**
 * One hit from the shop search, reduced to what a tile needs.
 *
 * `presetSlug`/`categorySlug` come from the item's `source_info.app_payload`
 * and are what make a result navigable — together they are this site's preset
 * URL, `/{categorySlug}/{presetSlug}`. Either can be absent on a hit that no
 * longer maps to a published preset.
 */
export interface SearchResultItem {
  id: string;
  title: string;
  mediaType: SearchMediaType;
  /** Still frame. The only url an image result needs. */
  posterUrl: string;
  /** The playable/full-size url. */
  mediaUrl: string;
  width: number;
  height: number;
  presetSlug: string | null;
  categorySlug: string | null;
}

export interface SearchResults {
  items: SearchResultItem[];
  /**
   * Set when the backend refuses the term (its own moderation), in which case
   * it is the message to show instead of results — not an error.
   */
  restrictionMessage: string | null;
}
